'use client';

import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import dynamic from 'next/dynamic';
import { ReactNode } from 'react';

import { LIGHT_THEME_KEY, Theme, themes } from '@repo/cc-ds';

export interface ThemeProviderCsrProps {
  readonly children: ReactNode;
  readonly theme?: Theme;
}

export const ThemeProviderCsr = dynamic(
  () =>
    Promise.resolve(({ children, theme = LIGHT_THEME_KEY }: ThemeProviderCsrProps) => (
      <MuiThemeProvider theme={themes[theme]}>{children}</MuiThemeProvider>
    )),
  { ssr: false },
);
